import { assert } from '@sama/js-core';
import { assertStore } from '../../../cross-team-shared/misc-utils';
import { isAnnotationOutput } from '../dsl/sensor-fusion/sensor-fusion-output.utils';
import { TaskWorkspaceStore } from './task-workspace-store';

export function getOutputAnnotationInfoStore(
  taskWorkspaceStore: TaskWorkspaceStore,
  outputName: string,
) {
  const outputAnnotationInfoStore = taskWorkspaceStore('outputAnnotationInfo')(
    outputName,
  );
  assertStore(
    outputAnnotationInfoStore,
    'outputAnnotationInfo should always be defined',
  );
  return outputAnnotationInfoStore;
}

export function getAnnotationOutput(
  taskWorkspaceStore: TaskWorkspaceStore,
  annotationOutputName: string,
) {
  const annotationOutput =
    taskWorkspaceStore.state().outputInfoByName[annotationOutputName].output;
  assert(
    isAnnotationOutput(annotationOutput),
    `Output ${annotationOutputName} is not an annotation output`,
  );
  return annotationOutput;
}

export function getSelectedToolStore(
  taskWorkspaceStore: TaskWorkspaceStore,
  outputName: string,
) {
  const outputAnnotationInfoStore = getOutputAnnotationInfoStore(
    taskWorkspaceStore,
    outputName,
  );
  return outputAnnotationInfoStore('selectedTool');
}
